import {combineReducers} from 'redux';
import SpecificAction, {reducer as SpecificPatientReducer, SpecificPatientTypes} from './specific/SpecificPatientRedux';
import AllAction, {reducer as AllPatientReducer, AllPatientTypes} from './all/AllPatientRedux';

export default combineReducers({
  all: AllPatientReducer,
  specific: SpecificPatientReducer
});

export const PatientTypes = {
  ...SpecificPatientTypes, 
  ...AllPatientTypes,
};

export const PatientActions = {
  ...SpecificAction, 
  ...AllAction,
};